/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiExternalApplication, ApiGroup } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ApplicationsGroupController.
 */
export class ApplicationsGroupRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /applications/{rootObjectId}/groups:query
     */
    public getLinkedObjects(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiGroup>>> {
        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequest>(`/applications/${rootObjectId}/groups:query`, listRequest);
    }

    /**
     * Calls POST /applications/{rootObjectId}/groups:prefill
     */
    public createPrefilled(rootObjectId: string): Promise<Result<ApiGroup>> {
        return this.http.post<Result<ApiGroup>, undefined>(`/applications/${rootObjectId}/groups:prefill`, undefined);
    }

    /**
     * Calls POST /applications/{rootObjectId}/groups/linkable:query
     */
    public getLinkableObjects(listRequest: ListRequest, showAll: boolean, rootObjectId: string): Promise<Result<ListInfo<ApiGroup>>> {
        const query = new URLSearchParams();
        query.set('showAll', `${showAll}`);

        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequest>(`/applications/${rootObjectId}/groups/linkable:query`, listRequest, query);
    }

    /**
     * Calls POST /applications/{rootObjectId}/groups
     */
    public addLinkedObject(id: string, rootObjectId: string): Promise<Result<ApiExternalApplication>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.post<Result<ApiExternalApplication>, undefined>(`/applications/${rootObjectId}/groups`, undefined, query);
    }

    /**
     * Calls DELETE /applications/{rootObjectId}/groups/{unlinkId}
     */
    public deleteLinkedObject(unlinkId: string, rootObjectId: string): Promise<Result<ApiExternalApplication>> {
        return this.http.delete<Result<ApiExternalApplication>>(`/applications/${rootObjectId}/groups/${unlinkId}`);
    }
}
